import newPalette from 'common/lib/theme/newPalette';

import { REFERRALS } from 'common/constants/copy';

import type { ThemeType } from 'common/types/Styles';

type ProcessKeys = keyof typeof REFERRALS.PROCESS;
const processKeys: ProcessKeys[] = ['SHARE_STEP', 'DISCOUNT_STEP', 'EARNINGS_STEP'];

export const referralsProcessSteps = processKeys.map((key) => {
  const step = REFERRALS.PROCESS[key];
  return {
    title: step.TITLE,
    description: step.DESCRIPTION,
    descriptionLine2: 'DESCRIPTION_LINE_2' in step ? step.DESCRIPTION_LINE_2 : undefined,
    disclaimer: 'DISCLAIMER' in step ? step.DISCLAIMER : undefined,
  };
});

// Always use the light version color
export const [promoTextColor] = newPalette.gray12;
export const promoGradientDegrees = 124;

export const promoGradientStart = ({ theme }: { theme: ThemeType }) =>
  theme.uiTheme === 'light' ? theme.color.orange6 : theme.color.orange9;

export const promoGradientEnd = ({ theme }: { theme: ThemeType }) =>
  theme.uiTheme === 'light' ? theme.color.yellow6 : theme.color.yellow9;
